// Team data for Chaturvedi Lab

export const principalInvestigator = {
  name: "Sonali Chaturvedi",
  title: "Assistant Professor",
  fullTitle: "Assistant Professor of Systems Biology",
  credentials: "Ph.D.",
  photo: "/team/sonali_chaturvedi.jpg",
  email: "sonalic@ucr.edu",
  bio: "Dr. Sonali Chaturvedi is an Assistant Professor of Systems Biology at the University of California, Riverside, where she leads the Systems, Synthetic & Quantitative Biology Lab. Her group investigates how complex biological systems make decisions, and how these processes can be modeled, engineered, and directed to improve clinical outcomes. By integrating systems and synthetic biology, the Chaturvedi Lab studies cellular and molecular circuit architecture at the interface of development, oncogenesis, and host–disease interactions.\n\nHer team develops complementary experimental and computational platforms to tackle these questions. Their work includes building synthetic circuits to probe network logic, engineering single-cell technologies to track cell-fate decisions, and designing predictive models that combine machine learning with emerging quantum-computing approaches. Viewing biology as a dynamic, information-rich system, the group uncovers generalizable design principles that guide therapeutic innovation.\n\nThe lab maintains a strong translational focus. Working with clinical partners across the country, Dr. Chaturvedi's team applies these principles to engineer therapies with enhanced resistance barriers, develop strategies to improve transplant safety, and optimize care for patients with chronic infections.",
  affiliations: [
    "Institute of Integrative Genome Biology",
    "Interdisciplinary Center for Quantitative Modeling in Biology",
    "Center for RNA Biology and Medicine",
    "Center for Infectious Disease and Vector Research",
    "Department of Microbiology and Plant Pathology",
    "School of Medicine Center for Molecular and Translational Medicine (MOLMED)",
    "Stem Cell Center"
  ],
  positions: [
    { title: "Assistant Professor of Virology", institution: "University of California, Riverside", year: "2024-Present" },
    { title: "Research Investigator", institution: "J David Gladstone Institutes", year: "2021-23" },
    { title: "Scientist", institution: "Gladstone Institutes", year: "2019-21" },
    { title: "Postdoctoral Fellow", institution: "J David Gladstone Institutes/UCSF", year: "2014-19" }
  ],
  education: [
    { degree: "Ph.D. in Virology", institution: "University of California, Riverside", year: "2009-14" },
    { degree: "M.S.", institution: "University of California, Riverside", year: "2009" }
  ],
  awards: [
    "NIH/NIGMS R35 MIRA Award - Maximizing Investigators' Research Award (2026-2031)",
    "Member for HIVD Study Section, NIH (2024)",
    "Regents Faculty Fellowship Award (2024)",
    "Distinguished Achievement in Scientific Leadership Award, Gladstone Institutes (2022)",
    "Distinguished Achievement in Science Award, Gladstone Institutes (2021)",
    "Best Poster Award, Gladstone Institutes Retreat (2019)",
    "Best Abstract Award, International Conference on Antiviral Research (2019)",
    "Best Poster Award, Bay Area Virology Symposium, UC Berkeley (2018)",
    "Career Advancement Award, Gladstone Institutes (2018)"
  ]
};

export const teamMembers = [
  {
    id: 1,
    name: "Ruthie Shenoy",
    title: "Lab Manager",
    photo: "/team/ruthie_shenoy.jpeg",
    category: "Research Staff"
  },
  {
    id: 9,
    name: "Hana Shaik",
    title: "Ph.D. student, GGB",
    photo: "/team/hana_shaik.jpg",
    category: "Graduate Students"
  },
  {
    id: 14,
    name: "Julie West",
    title: "Ph.D. student, CMDB",
    photo: "/team/julie_west.jpg",
    category: "Graduate Students"
  },
  {
    id: 15,
    name: "Joseph Cruz",
    title: "Graduate Student, Biomedical Sciences",
    photo: "/team/joseph_cruz.jpg",
    category: "Graduate Students"
  },
  {
    id: 16,
    name: "Darlyn Martinez Marroquin",
    title: "Graduate Student, Biomedical Sciences",
    photo: "/team/darlyn_martinez_marroquin.jpg",
    category: "Graduate Students"
  },
  {
    id: 4,
    name: "Dhriti Lathker",
    title: "NIH MARC Fellow",
    photo: "/team/dhriti_lathker.jpg",
    category: "Fellows"
  },
  {
    id: 6,
    name: "Zainab Jalali",
    title: "RAMP Fellow, CIRM",
    photo: "/team/zainab_jalali.png",
    category: "Fellows"
  },
  {
    id: 10,
    name: "Harshika Sharma",
    title: "Visiting Scholar in Machine Learning",
    photo: "/team/harshika_sharma.jpg",
    category: "Visiting Scholars"
  },
  {
    id: 11,
    name: "Kripa Panday",
    title: "Undergraduate Researcher",
    photo: "/team/kripa_panday.jpg",
    category: "Undergraduate Researchers"
  },
  {
    id: 12,
    name: "Hyla Alrajab",
    title: "Undergraduate Researcher",
    photo: "/team/hyla_alrajab.jpg",
    category: "Undergraduate Researchers"
  },
  {
    id: 13,
    name: "Isabela Sforcin",
    title: "Undergraduate Machine Learning Researcher",
    photo: "/team/isabela_sforcin.jpg",
    category: "Undergraduate Researchers"
  }
];

export const teamCategories = [
  "Graduate Students",
  "Fellows",
  "Research Staff",
  "Undergraduate Researchers",
  "Visiting Scholars"
];

export const labAlumni = [
  {
    id: 1,
    name: "Michael Collins",
    title: "Full-Time Position at CS Startup",
    year: "2026"
  },
  {
    id: 2,
    name: "Sooraj Verma",
    title: "In Graduate School",
    year: "2026"
  },
  {
    id: 3,
    name: "Areg Mehrabian",
    title: "In Medical School",
    year: "2026"
  }
];
